import React, { Component } from "react";
import { connect } from 'react-redux';
import { getVideoShipments } from "redux/actions/report-actions";
import ReactValidator from "simple-react-validator";
import DatePicker from "react-datepicker";
import { Row, Col, Grid } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import 'react-table/react-table.css';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player';
import { dateFormatMy, returnBoleanWithColumnMatch, BytesToMb, hasRole } from 'helper/helperFunctions';
import Pagination from "../../ThemeComponents/Pagination";

const moment = window.moment;

class VideoShipmentPage extends Component {
	constructor(props) {
		super(props);
		this.dateValidator = new ReactValidator();
		this.state = {
			fromDate: '',
			toDate: '',
			pageSize: 10,
			page: 0,
			sorted: '',
		}
		this.table = React.createRef();
	}
	DateChangeHandler = (value, field) => {
		this.setState({ [field]: value === null ? '' : moment(value).format("YYYY-MM-DD") }, () => {
			if (this.dateValidator.allValid()) {
				this.pagination.dataCall();;
			} else {
				this.dateValidator.showMessages();
				this.forceUpdate();
			}
		})
	}
	dateElement(label, name, value, rules) {
		var selectedDate = this.state[name] !== '' ? new Date(this.state[name]) : '';
		const { fromDate, toDate } = this.state;
		return (
			<div className='form-group fullCalendar' id={name}>
				<label>{label}</label>
				<DatePicker className="form-control calender_icon" dateFormat={hasRole(['gm admin']) ? 'dd/MM/yyyy' : 'MM/dd/yyyy'} selected={selectedDate} name={name} onChange={(event) => this.DateChangeHandler(event, name)} />
				{
					(fromDate !== '' && toDate !== '') &&
					this.dateValidator.message(name, value, rules)
				}
			</div>
		);
	}
	reportsPaginationData = (page = this.state.page, sorted = this.state.sorted, pageSize = this.state.pageSize) => {
		const { fromDate, toDate } = this.state;
		this.props.getReportsCall(1, fromDate, toDate, page, pageSize, sorted);
	}

	paginationCall = (data) => {
		const { fromDate, toDate } = this.state;
		return this.props.getReportsCall(1, fromDate, toDate, data.page, data.pageSize, data.sort);
	}

	render() {
		const { toDate, fromDate } = this.state;
		const { /*reportsData, REPORTSpages, loadingOrder,*/ REPORTStotal_orders } = this.props;
		const columns = [
			{
				Header: "Report Testing",
				headerClassName: 'headerPagination',
				columns: [
					{
						Header: "Barcode",
						accessor: "barcode",
                        width: 200,
						className: "action-center",
						Cell: ({ value, original }) => {
							return <Link to={'/Admin/' + (original.reorder ? original.reorder : original.id) + '/order-edit'} className="blue_link">{value}</Link>
						},
						sortable: false,
					},
					{
						Header: "Date",
						accessor: "video_ship_status",
						Cell: ({ value }) => (

							<div>
								{dateFormatMy(value[0].updated_at)}
							</div>
						),
						className: "action-center",
						sortable: false,
					},

					{
						Header: "Type",
						accessor: "order_resources",
						className: "action-center",
						Cell: ({ value }) => (
							<React.Fragment>
								{
									returnBoleanWithColumnMatch(value, 'resourceTypeSlug', 'full_video')
										?
										value.map(
											(prop, key) => {
												if (prop.resourceTypeSlug === 'full_video') {
													return (
														<React.Fragment key={key}>
															<ReactPlayer className='react-player' url={prop.file_path} controls={true} width={'200px'} height={'100px'} />
															<div>{BytesToMb(prop.file_size)} MB </div>
														</React.Fragment>
													);
												} else {
													return null;
												}
											}
										)
										:
										<span>Full video is not available</span>
								}
							</React.Fragment>
						),
						sortable: false,
					}
				]
			}
		];
		return (
			<div className="content">
				<Grid fluid>
					<Row>
						<Col md={12}>
							<Card
								ctTableResponsive
								content={
									<div>
										<Grid fluid>
											<div className="row">
												<Col md={12}>
													<div className="secHeading">Shipment Reporting</div>
												</Col>

												<Col md={4} >
													<div className='row flexElem flexResponsive align-items-center' >
														<div className="col-md-6" >
															{
																this.dateElement('Date From', 'fromDate', fromDate !== '' && moment(fromDate, 'YYYY-MM-DD'), [{ before_or_equal: moment(this.state.toDate) }])
															}
														</div>
													</div>
												</Col>
												<Col md={4} >
													<div className='row flexElem flexResponsive align-items-center' >
														<div className="col-md-6" >
															{
																this.dateElement('Date To', 'toDate', toDate !== '' && moment(toDate, 'YYYY-MM-DD'), [{ after_or_equal: moment(this.state.fromDate) }])
															}
														</div>

													</div>
												</Col>
												<Col md={12}>
													<div>Total Records: {REPORTStotal_orders ? REPORTStotal_orders : 0}</div>
												</Col>

												{/* <Col md={12} className="mt-md">
					                        	<ReactTable
													ref={this.table}
													noDataText= 'No shipment report found'
						                            data={reportsData}
						                            pages={REPORTSpages}
						                            columns={columns}
						                            defaultPageSize={10}
						                            loading={loadingOrder}
						                            className="-striped listing"
						                            loadingText={'Loading...'}
						                            pageData={this.reportsPaginationData}
						                            manual
						                            onFetchData={(state, instance) => {

						                            	var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                              							state.pageData(state.page + 1, sort, state.pageSize);
						                            }}
					                          	/>
					                        </Col> */}
												<Pagination
													ref={(p) => this.pagination = p}
													showPagination={false}
													columns={columns}
													pageSize={10}
													noDataText='No shipment report found'
													getDataCall={this.paginationCall}
													filterView={false}
													// downloadData={true}
													// downloadFileName={'Orders'}
													// lowerContent = {null}
													// filterPlaceHolder = {'Orders'}
													getRowProps={this.getRowProps}
												// showAllToggle={true}
												/>
											</div>
										</Grid>
									</div>
								} />
						</Col>
					</Row>
				</Grid>
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return ({
		getReportsCall: (value, fromDate, toDate, page, pageSize, sorted) => { return dispatch(getVideoShipments(value, fromDate, toDate, page, pageSize, sorted)) },//example function
		success: (response) => { return dispatch({ type: 'GET_ALL_VIDEO_SHIPMENT_SUCCESS', payload: response }) }
	});
};

function mapStateToProps(state) {
	const { reportsData, REPORTSpages, REPORTScurrent_page, REPORTStotal_orders, loadingOrder } = state.reportReducer;
	return {
		reportsData, REPORTSpages, REPORTScurrent_page, REPORTStotal_orders, loadingOrder
	};
}


const VideoShipment = connect(mapStateToProps, mapDispatchToProps)(VideoShipmentPage);
export default VideoShipment;
